import styled from 'react-emotion'
import { colors, fonts, generic } from 'src/shared/variables'

export const Wrapper = styled.div`
    background: ${colors.messyBG};
    padding: ${generic.padding.l};
    height: 300px;
    overflow-y: hidden;
`

export const Controls = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-block: ${generic.padding.l};
`

export const Top = styled.div`
    display: flex;
    position: relative;
`

export const TopWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    margin-left: ${generic.padding.l};
    color: ${colors.messyText};
`

export const LogoLink = styled.a`
    position: absolute;
    top: 0;
    right: 0;
    transition: all 0.2s;

    &:hover {
        filter: brightness(1.5);
    }
`

export const ShowTitle = styled.span`
    font-size: 23px;
`

export const ShowImage = styled.img`
    height: 100px;
    border-radius: ${generic.borderRadius.sm};
`

export const EpisodeTitle = styled.span`
    margin-top: 0.25rem;
    font-size: ${fonts.size.small};
    color: ${colors.messyText};
`

export const ProgressWrapper = styled.div`
    display: flex;
    align-items: center;
    font-size: ${fonts.size.extraSmall};
    width: calc(100% - 48px);
    margin-left: ${generic.padding.l};
`

interface ProgressBarProps {
    width: string;
}

export const ProgressBar = styled.div<ProgressBarProps>(({ width }) => ({
    height: 5,
    background: colors.messyDGrey,
    flex: 1,
    cursor: 'pointer',
    borderRadius: 2,
    margin: '0 0.5rem',
    '&:after': {
        display: 'block',
        content: '""',
        width,
        height: 5,
        borderRadius: 2,
        background: colors.messyText,
    },
}));

export const Show = styled.div`
    display: flex;
    flex-direction: column;
`

export const TogglePlayButton = styled.button`
    width: 32px;
    height: 32px;
    background-color: ${colors.messyGreen};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${generic.borderRadius.sm};
    padding: ${generic.padding.m};
    cursor: pointer;

    &:hover{
        background-color: ${colors.messyLGreen};
    }

    img {
        height: 1rem;
    }
`

export const Bottom = styled.div`
    color: white;
    overflow-y: auto;
    max-height: 150px;
    font-size: ${fonts.size.extraSmall};
    margin-right: -0.5rem;
`

export const Episode = styled.div`
    padding: 0.5rem;
    cursor: pointer;
    transition: background-color 0.2s;
    &:hover {
        background-color: ${colors.messyDBlue};
    }
`
